import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { TemplateType } from '../shared/utils/template-type';
import { LocalStorageService } from 'ng2-webstorage';
import cssVars from 'css-vars-ponyfill';

@Component({
	selector: 'app-root',
	template: `
	<router-outlet></router-outlet>
	<router-outlet name="notification" ></router-outlet>
	<router-outlet name="popup"></router-outlet>
	`,
	styleUrls: []

})
export class RootComponent implements OnInit {
	whatBank: any = {};

	constructor(
		public router: Router,
		private templateType: TemplateType,
		private $localStorage: LocalStorageService,
	) { }

	ngOnInit() {
		this.changeSkin();
		cssVars();
	}

	DangXuat() {

	}

	// Change to red skin for Huanan
	changeSkin() {
		this.templateType.callAPIGetCustomerIndex()
			.subscribe((responseIndex => {
				let data: any = {};
				this.$localStorage.store("cindex", responseIndex);
				this.templateType.checkBank(data, responseIndex);
				if (data.isHuanan === true) {
					$('#indexBody').addClass('change-skin');
				}
				else {
					$('#indexBody').removeClass('change-skin');
				}
			}))
	}

}
